import fetch from "unfetch";
import { merge } from "lodash";
import { getAuthCookie } from "../utils/cookie";
import axios from "axios";
import { stringify } from "query-string";

// const host = "https://apps.optanium.com/elsa/openapi";
// const host = "https://openapi.optanium.com/elsa/openapi";
export const fallbackUrl = "https://apps.optanium.com/elsa/openapi";
export const host = window.location.origin.includes("localhost")
  ? fallbackUrl
  : window.location.origin + "/elsa/openapi";
console.log("host", host);

export const SERVER_METHODS = { GET: "GET", POST: "POST" };
export const requestServer = async (method, path, payload) => {
  let options = {
    headers: { esid: getAuthCookie(), version: process.env.REACT_APP_VERSION },
  };
  console.log(options);
  if (method === SERVER_METHODS.POST) {
    options = merge(options, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      mode: "no-cors",
    });
  } else {
    options = merge(options, {
      method: SERVER_METHODS.GET,
    });
  }
  let res = await fetch(host + path, options);
  return res;
};

function paramsSerializer(params) {
  return stringify(params);
}

export const API = axios.create({
  baseURL: host,
  paramsSerializer,
});

API.interceptors.request.use((config) => {
  config.headers.common["esid"] = getAuthCookie();
  return config;
});
